// extracted by mini-css-extract-plugin
export var container = "Highlights-module__container___rvrtH";
export var content = "Highlights-module__content___lAGle";
export var heading = "Highlights-module__heading___Hj6hF";
export var highlights = "Highlights-module__highlights___t5_qt";
export var paragraph = "Highlights-module__paragraph___r426k";